/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum TaskHeldReason {
  access_blacklisted_app = 'access_blacklisted_app',
  blacklisted_app = 'blacklisted_app',
  dedupe_change = 'dedupe_change',
  paymentIssue = 'paymentIssue',
  plan_limit = 'plan_limit',
  stale_auth = 'stale_auth',
  step_limit = 'step_limit',
  task_limit = 'task_limit',
  throttled = 'throttled',
  too_many = 'too_many',
  unknown = 'unknown',
}

//==============================================================
// END Enums and Input Objects
//==============================================================
